import type { CustomerDetailsSchemas, FundingApplicationSchemas } from "api-types";

export enum ConnectorCategory {
  ECOMMERCE = "SHOPPING",
  ANALYTICS = "ANALYTICS",
  MARKETING = "MARKETING",
  BANKING = "BANKING",
  ACCOUNTING = "ACCOUNTING",
  OTHER = "OTHER",
}

export enum UploadDocumentType {
  MANAGEMENT_ACCOUNTS = "management-accounts",
  BALANCE_SHEET = "balance-sheet",
  PROFIT_AND_LOSS = "profit-and-loss",
  SUSA = "susa",
  POOL_BANCARIO = "pool-bancario",
  CASH_FLOW_FORECAST = "cash-flow-forecast",
  COMPANY_DEBT_AGREEMENT = "debt-agreement",
}

export type FundingApplicationDocumentType = Exclude<
  FundingApplicationSchemas.DocumentType,
  "broker-application-form" | "bank-statement" | "other" | "proof-of-registration"
>;

export type BusinessModelData = CustomerDetailsSchemas.BusinessModel | null;
